import React from 'react';
import AppListToolbarGlobal, { type CompanyOption } from '@/__core/components/AppLisstToolbarGlobal';

export interface StockBalanceToolbarGlobalProps {
  /** @deprecated Chỉ dùng khi test; mặc định lấy từ auth + resolveModuleAccessibleCompanies */
  companies?: CompanyOption[];
  fetchCompanies?: () => Promise<CompanyOption[]>;
  searchQuery?: string;
  onSearchChange?: (query: string) => void;
  onSearchSubmit?: () => void;
  onToggleAdvancedSearch?: () => void;
  isAdvancedSearchOpen?: boolean;
  onFilterChange?: (field: string, value: string) => void;

  filters?: {
    company: string;
    stockState: string;
  };
  stockStateOptions?: Array<{ id: string; name: string }>;
  onRefresh?: () => void;
}

export default function StockBalancesToolbarGlobal({
  companies,
  searchQuery = '',
  onSearchChange,
  onSearchSubmit,
  onToggleAdvancedSearch,
  isAdvancedSearchOpen = false,
  filters = { company: 'all', stockState: 'all' },
  onFilterChange,
  stockStateOptions = [],
  onRefresh,
}: StockBalanceToolbarGlobalProps) {
  const stockStateFilterOptions = React.useMemo(
    () => stockStateOptions.map((option) => ({ value: option.id, label: option.name })),
    [stockStateOptions]
  );

  const advancedFilterFields = React.useMemo(
    () => [
      {
        key: 'stockState',
        label: 'Tình trạng',
        labelWidth: 90,
        value: filters.stockState,
        placeholder: 'Chọn tình trạng',
        options: stockStateFilterOptions,
        onChange: (value: string) => onFilterChange?.('stockState', value),
        gridSize: { xs: 12, sm: 6, md: 6 },
      },
    ],
    [filters.stockState, onFilterChange, stockStateFilterOptions]
  );

  return (
    <AppListToolbarGlobal
      scopeModule='stockbalance'
      companies={companies}
      searchPlaceholder='Tìm theo mã vật tư, tên vật tư, kho, lô, vị trí kệ...'
      searchQuery={searchQuery}
      onSearchChange={onSearchChange}
      onSearchSubmit={onSearchSubmit}
      isAdvancedSearchOpen={isAdvancedSearchOpen}
      onToggleAdvancedSearch={onToggleAdvancedSearch}
      selectedCompany={filters.company}
      onCompanyChange={(id) => onFilterChange?.('company', id)}
      advancedFilterFields={advancedFilterFields}
    />
  );
}
